import { map } from "lodash";
import { AppointmentManagementItem, IAppointmentManagementItem } from ".";
export interface IAppointmentManagementGroupingModel {
    status: string;
    clinicDate: Date;
    partnerName: string;
    address: string;
    city: string;
    state: string;
    zip: string;

    firstName: string;
    lastName: string;
    email: string;
    phone: string;
    wasPriorCustomer: boolean;

    clinicId: number;
    storeCode: string;
    intakePublicId: string;
    canViewIntake: boolean;
    canConfirm: boolean;
    canSendVisitCompletion: boolean;
    canCancel: boolean;
    canReschedule: boolean;
    canRebook: boolean;
    sortOrder: number;
    rescheduleViaVOB: boolean;
    vobRescheduleUrl: string;
    isHospitalReservation: boolean;
    hospitalName: string;
    hospitalPhone: string;
    publicAppointmentTypeId: string;
    items: IAppointmentManagementItem[];
}

export class AppointmentManagementGroupingModel implements IAppointmentManagementGroupingModel {
    status: string;
    clinicDate: Date;
    partnerName: string;
    address: string;
    city: string;
    state: string;
    zip: string;

    firstName: string;
    lastName: string;
    email: string;
    phone: string;
    wasPriorCustomer: boolean;

    clinicId: number;
    storeCode: string;
    intakePublicId: string;
    canViewIntake: boolean;
    canConfirm: boolean;
    canSendVisitCompletion: boolean;
    canCancel: boolean;
    canReschedule: boolean;
    canRebook: boolean;
    sortOrder: number;
    rescheduleViaVOB: boolean;
    vobRescheduleUrl: string;
    isHospitalReservation: boolean;
    hospitalName: string;
    hospitalPhone: string;
    publicAppointmentTypeId: string;
    items: AppointmentManagementItem[] = [];

    constructor(params: Partial<IAppointmentManagementGroupingModel> = {}) {
        const {
            status = '',
            clinicDate = '',
            partnerName = '',
            address = '',
            city = '',
            state = '',
            zip = '',
            firstName = '',
            lastName = '',
            email = '',
            phone = '',
            wasPriorCustomer = false,
            clinicId = 0,
            storeCode = '',
            intakePublicId = '',
            canViewIntake = false,
            canConfirm = false,
            canSendVisitCompletion = false,
            canCancel = false,
            canReschedule = false,
            canRebook = false,
            sortOrder = 0,
            rescheduleViaVOB = false,
            vobRescheduleUrl = '',
            isHospitalReservation = false,
            hospitalName = '',
            hospitalPhone = '',
            publicAppointmentTypeId = '',
            items = [] as Array<IAppointmentManagementItem>
        } = params;

        this.status = status;
        this.clinicDate = new Date(clinicDate);
        this.partnerName = partnerName;
        this.address = address;
        this.city = city;
        this.state = state;
        this.zip = zip;

        this.firstName = firstName;
        this.lastName = lastName;
        this.email = email;
        this.phone = phone;
        this.wasPriorCustomer = wasPriorCustomer;

        this.clinicId = clinicId;
        this.storeCode = storeCode;
        this.intakePublicId = intakePublicId;
        this.canViewIntake = canViewIntake;
        this.canConfirm = canConfirm;
        this.canSendVisitCompletion = canSendVisitCompletion;
        this.canCancel = canCancel;
        this.canReschedule = canReschedule;
        this.canRebook = canRebook;
        this.sortOrder = sortOrder;
        this.rescheduleViaVOB = rescheduleViaVOB;
        this.vobRescheduleUrl = vobRescheduleUrl;
        this.hospitalName = hospitalName;
        this.hospitalPhone = hospitalPhone;
        this.isHospitalReservation = isHospitalReservation;
        this.publicAppointmentTypeId = publicAppointmentTypeId;
        map(items, (item) => { this.items.push(new AppointmentManagementItem(item)); });
    }
}
